import { motion } from 'framer-motion';

export default function AboutSection() {
  return (
    <section id="about" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/07ad7141c311a7160b38f0cefce25ed0/807ced00d691acd5d42c55d359f03d3e.png"
                alt="Dr. Savai - A.I. Prompt Engineering Specialist"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="text-center mt-6">
              <h3 className="text-2xl font-bold text-charcoal mb-2">DR. SAVAI</h3>
              <p className="text-xl font-bold text-primary">A.I. PROMPT ENGINEERING SPECIALIST</p>
            </div>
          </motion.div>

          {/* Description */}
          <div className="prose prose-lg max-w-none">
            <p className="text-slate-700 leading-relaxed mb-6">
              We don't just advise—we partner with you throughout your AI journey. From initial
              strategy development to implementation oversight and ongoing optimization, we're
              committed to your success. Our clients benefit from our extensive network of AI
              vendors, our proven frameworks, and our hands-on approach to problem-solving.
            </p>
            <p className="text-slate-700 leading-relaxed">
              Whether you're just beginning to explore AI possibilities or looking to optimize
              existing initiatives, we bring the expertise and perspective you need to make
              confident decisions and achieve measurable results.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
